import { Component, ChangeDetectionStrategy } from '@angular/core';
import {FooterComponent} from "../footer/footer.component";
import {HeaderComponent} from "../header/header.component";
import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-main-layout',
    imports: [
        FooterComponent,
        HeaderComponent,
        RouterOutlet,
    ],
    templateUrl: './main-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './main-layout.component.css'
})
export class MainLayoutComponent {

}
